export default __webpack_public_path__ + "static/12_months-f5a48366c368aa4cb0b1278093c9d385.jpeg";